import { FileText, Film, ImageIcon } from "lucide-react";

import type { MaterialKind } from "./materials";

export const KIND_ICON: Record<MaterialKind, typeof FileText> = {
  image: ImageIcon,
  video: Film,
  document: FileText,
};
